import PropTypes from "prop-types";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { getBrandDisplayName, getRobotsMetaTag } from "app/reducers/partnerSelector";
import { useSelector, shallowEqual } from "react-redux";
import { OFFER_PRICE_TYPES } from "app/constants";
import { useIntl } from "react-intl";
import { formatAmountForDisplay } from "app/utils/utils";
import appGlobalsContext from "app/AppGlobalsContext";
import { useContext } from "react";

const FicheProduitHeadMetadata = ({ ficheProduit = {}, desktopSlideShowPhotos = [] }) => {
	const {
		robotsMetaTag,
		currencyCode,
		brandDisplayName,
		titleFromSanity,
		descriptionFromSanity,
	} = useSelector(mapStateToProps, shallowEqual);

	let metaDescription = "page.description.product.exclusive";

	const { shop } = useContext(appGlobalsContext);

	const intl = useIntl();

	switch (ficheProduit?.fromPriceType?.type) {
		case OFFER_PRICE_TYPES.FROM_PRICE_TYPE_SAVE_UP_TO:
			metaDescription = "page.description.product.saveupto";
			break;
		case OFFER_PRICE_TYPES.FROM_PRICE_TYPE_FROM:
		case OFFER_PRICE_TYPES.FROM_PRICE_TYPE_FROM_WITH_FLIGHT:
			metaDescription = "page.description.product.from";
			break;
		case OFFER_PRICE_TYPES.FROM_PRICE_TYPE_EXCLUSIVE:
			metaDescription = "page.description.product.exclusive";
			break;
		default:
			metaDescription = "page.description.product.catalog";
			break;
	}

	const ogImageAlt = `${ficheProduit?.name} ${ficheProduit?.category}* | ${brandDisplayName}`;

	const amount = intl.formatNumber(ficheProduit?.fromPriceType?.value, {
		style: "currency",
		currency: currencyCode,
		currencyDisplay: "symbol",
		useGrouping: true,
		minimumFractionDigits: 0,
		maximumFractionDigits: 2,
	});

	const pricingValue = formatAmountForDisplay(amount, currencyCode, shop);

	const title = titleFromSanity || "page.title.product";
	const description = descriptionFromSanity || metaDescription;

	return (
		<HeadMetadata
			description={description}
			descriptionAttributes={{
				pricingValue,
				country: ficheProduit?.country,
			}}
			title={title}
			titleAttributes={{ name: ficheProduit.name, category: ficheProduit.category }}
			robotsMetaTag={robotsMetaTag}
			imageUrl={
				desktopSlideShowPhotos && desktopSlideShowPhotos[0]
					? desktopSlideShowPhotos[0].url
					: ""
			}
		>
			<meta property="og:image:alt" content={ogImageAlt} />
		</HeadMetadata>
	);
};

FicheProduitHeadMetadata.propTypes = {
	ficheProduit: PropTypes.object,
	currencyCode: PropTypes.string,
	brandDisplayName: PropTypes.string,
	desktopSlideShowPhotos: PropTypes.array,
	robotsMetaTag: PropTypes.array,
	titleFromSanity: PropTypes.string,
	descriptionFromSanity: PropTypes.string,
};

const mapStateToProps = state => {
	const robotsMetaTag = getRobotsMetaTag(state);
	return {
		robotsMetaTag: robotsMetaTag?.product,
		brandDisplayName: getBrandDisplayName(state),
		currencyCode: state?.currency,
		titleFromSanity: state.brand?.seo?.productPagePP?.metaTitle,
		descriptionFromSanity: state.brand?.seo?.productPagePP?.metaDescription,
	};
};

export default FicheProduitHeadMetadata;
